module.exports = __webpack_public_path__ + "media/src/web/images/logo-white-81eda8dd2eda704bbcc0e978e75f7609.webp";